import { ButtonContainer } from "./SearchButtonsStyles";

export function SearchButton(props: any) {
  const { onClick, showfullName, width, height } = props;
  return (
    <ButtonContainer
      onClick={onClick}
      showfullName={showfullName}
      width={width}
      height={height}
    >
      {showfullName && "Aplicar filtros"}
      <i
        style={{
          fontSize: "0.8em",
          fontWeight: 700,
          marginLeft: showfullName ? "1.5rem" : "0",
        }}
        className="pi pi-chevron-right"
      ></i>
    </ButtonContainer>
  );
}

export function ResetButton({ onClick }) {
  return (
    <ButtonContainer onClick={onClick}>
      <i
        style={{ fontSize: "0.8em", fontWeight: 700 }}
        className="pi pi-replay"
      ></i>
    </ButtonContainer>
  );
}
